var colors = {
  WHITE: '#FFFFFF',
  BLACK: '#000000',
  BROWN_100: '#A5673F',
  BROWN_200: '#F4C6A7',
  BROWN_300: '#C98F69',
  BROWN_400: '#834720',
  BROWN_500: '#592707',
  FLOW_BLUE_100: '#E1EFFF',
  FLOW_BLUE_200: '#A4CBFC',
  FLOW_BLUE_300: '#3283E6',
  FLOW_BLUE_400: '#0051B2',
  FLOW_BLUE_500: '#0C2D53',
  GRAY_100: '#FAFBFC',
  GRAY_200: '#F2F5F7',
  GRAY_300: '#E4E7EB',
  GRAY_400: '#D8DDE3',
  GRAY_500: '#B5BEC9',
  GRAY_600: '#9BA6B3',
  GRAY_700: '#77818F',
  GRAY_800: '#4D5866',
  GRAY_900: '#17181A',
  GREEN_100: '#DAFDD4',
  GREEN_200: '#DAFDD4',
  GREEN_300: '#128A00',
  GREEN_400: '#0F5E03',
  GREEN_500: '#0F5E03',
  OLIVE_100: '#B5CC18',
  OLIVE_200: '#E7F96C',
  OLIVE_300: '#CDE240',
  OLIVE_400: '#91A509',
  OLIVE_500: '#6E7E00',
  ORANGE_100: '#FDF8F3',
  ORANGE_200: '#FAE3CD',
  ORANGE_300: '#D9822B',
  ORANGE_400: '#95591E',
  ORANGE_500: '#6D3805',
  PINK_100: '#F28CC6',
  PINK_200: '#E85DAC',
  PINK_300: '#E03997',
  PINK_400: '#D81583',
  PINK_500: '#BA0069',
  PURPLE_100: '#A433C8',
  PURPLE_200: '#CD82E5',
  PURPLE_300: '#B755D6',
  PURPLE_400: '#9211BC',
  PURPLE_500: '#710594',
  RED_100: '#FAE4DE',
  RED_200: '#F5A48F',
  RED_300: '#D2431F',
  RED_400: '#921D00',
  RED_500: '#551B0D',
  SKY_BLUE_100: '#E8F9FF',
  SKY_BLUE_200: '#AAE9FF',
  SKY_BLUE_300: '#35C2F5',
  SKY_BLUE_400: '#087AA3',
  SKY_BLUE_500: '#134658',
  TEAL_100: '#F1FBFC',
  TEAL_200: '#D2EEF3',
  TEAL_300: '#14B5D0',
  TEAL_400: '#007489',
  TEAL_500: '#005D6E',
  VIOLET_100: '#ECDEFF',
  VIOLET_200: '#C194FF',
  VIOLET_300: '#7B35DE',
  VIOLET_400: '#411480',
  VIOLET_500: '#210B40',
  YELLOW_100: '#FFF7E5',
  YELLOW_200: '#FFE7B0',
  YELLOW_300: '#E6B137',
  YELLOW_400: '#B4810B',
  YELLOW_500: '#5E4200'
};
export default colors;